"use client";

import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { useEffect, useState } from "react";
import type { KeyboardEvent as ReactKeyboardEvent } from "react";
import { SortDirection } from "@/entities/ISort";
import CommonTableSortIcon from "@/components/user/utils/icons/CommonTableSortIcon";
import type { CommonSelectItemProps } from "../CommonSelect";
export default function CommonTabsTab(props) {
  const $ = _c(46);
  const {
    item,
    activeItem,
    setSelected,
    sortDirection,
    onKeyDown,
    buttonRef,
    disabled: t0,
    fill: t1,
    size: t2
  } = props;
  const disabled = t0 === undefined ? false : t0;
  const fill = t1 === undefined ? true : t1;
  const size = t2 === undefined ? "md" : t2;
  let t3;
  if ($[0] !== activeItem || $[1] !== item.value) {
    t3 = () => item.value === activeItem;
    $[0] = activeItem;
    $[1] = item.value;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const getIsActive = t3;
  const [isActive, setIsActive] = useState(getIsActive());
  let t4;
  if ($[3] !== getIsActive) {
    t4 = () => {
      setIsActive(getIsActive());
    };
    $[3] = getIsActive;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== activeItem) {
    t5 = [activeItem];
    $[5] = activeItem;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  if ($[7] !== isActive) {
    t6 = () => {
      let response;
      if (isActive) {
        response = "tw-bg-iron-800 tw-text-iron-100";
      } else {
        response = " tw-bg-iron-950 hover:tw-bg-iron-900 tw-text-iron-500 hover:tw-text-iron-100";
      }
      return response;
    };
    $[7] = isActive;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const getDynamicClasses = t6;
  const [dynamicClasses, setDynamicClasses] = useState(getDynamicClasses());
  let t7;
  if ($[9] !== getDynamicClasses) {
    t7 = () => {
      setDynamicClasses(getDynamicClasses());
    };
    $[9] = getDynamicClasses;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== isActive) {
    t8 = [isActive];
    $[11] = isActive;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  useEffect(t7, t8);
  const [shouldRotate, setShouldRotate] = useState(false);
  let t9;
  if ($[13] !== disabled || $[14] !== item.value || $[15] !== setSelected) {
    t9 = () => {
      if (disabled) {
        return;
      }
      setSelected(item.value);
      setShouldRotate(false);
    };
    $[13] = disabled;
    $[14] = item.value;
    $[15] = setSelected;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const onSelected = t9;
  const tooltip = "tooltip" in item && typeof item.tooltip === "string" ? item.tooltip : undefined;
  const t10 = fill ? "tw-flex-1" : undefined;
  const t11 = isActive ? "tw-bg-gradient-to-b tw-from-iron-700 tw-to-iron-800" : undefined;
  let t12;
  if ($[17] !== t10 || $[18] !== t11) {
    t12 = clsx("tw-p-[1px] tw-flex tw-rounded-lg", t10, t11);
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const t13 = isActive ? 0 : -1;
  let t14;
  let t15;
  if ($[20] !== disabled) {
    t14 = () => !disabled && setShouldRotate(true);
    t15 = () => !disabled && setShouldRotate(false);
    $[20] = disabled;
    $[21] = t14;
    $[22] = t15;
  } else {
    t14 = $[21];
    t15 = $[22];
  }
  const t16 = `${dynamicClasses} ${disabled ? "tw-cursor-not-allowed tw-opacity-60" : ""} ${fill ? "tw-flex-1" : ""} ${size === "sm" ? "tw-px-2 tw-py-1 tw-text-xs" : "tw-px-3 tw-py-1.5 tw-text-sm"} tw-whitespace-nowrap tw-leading-5 tw-font-medium tw-border-0 tw-rounded-lg tw-transition-all tw-duration-300 tw-ease-out tw-flex tw-items-center tw-justify-center tw-gap-2`;
  let t17;
  if ($[23] !== item.badge) {
    t17 = !!item.badge && item.badge > 0 && <span className="tw-bg-primary-500 tw-text-white tw-text-[10px] tw-font-bold tw-px-1.5 tw-py-0.5 tw-rounded-full tw-min-w-[18px] tw-h-[18px] tw-flex tw-items-center tw-justify-center">{item.badge}</span>;
    $[23] = item.badge;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== isActive || $[26] !== shouldRotate || $[27] !== sortDirection) {
    t18 = sortDirection && <span className="-tw-mt-1"><CommonTableSortIcon direction={isActive ? sortDirection : SortDirection.DESC} isActive={isActive} shouldRotate={isActive && shouldRotate} /></span>;
    $[25] = isActive;
    $[26] = shouldRotate;
    $[27] = sortDirection;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== buttonRef || $[30] !== disabled || $[31] !== isActive || $[32] !== item.label || $[33] !== onKeyDown || $[34] !== onSelected || $[35] !== t13 || $[36] !== t14 || $[37] !== t15 || $[38] !== t16 || $[39] !== t17 || $[40] !== t18 || $[41] !== tooltip) {
    t19 = <button type="button" role="tab" aria-selected={isActive} tabIndex={t13} ref={buttonRef} title={tooltip} disabled={disabled} onClick={onSelected} onKeyDown={onKeyDown} onMouseEnter={t14} onMouseLeave={t15} className={t16}>{item.label}{t17}{t18}</button>;
    $[29] = buttonRef;
    $[30] = disabled;
    $[31] = isActive;
    $[32] = item.label;
    $[33] = onKeyDown;
    $[34] = onSelected;
    $[35] = t13;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
    $[39] = t17;
    $[40] = t18;
    $[41] = tooltip;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== t12 || $[44] !== t19) {
    t20 = <div className={t12}>{t19}</div>;
    $[43] = t12;
    $[44] = t19;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  return t20;
}